var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#FEE8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 18.42h1.28v1.28h-1.28v-1.28zm0-5.12h1.28v3.84h-1.28V13.3zm.634-3.2A6.397 6.397 0 009.6 16.5c0 3.533 2.86 6.4 6.394 6.4a6.404 6.404 0 006.406-6.4c0-3.532-2.867-6.4-6.406-6.4zM16 21.62a5.119 5.119 0 01-5.12-5.12A5.119 5.119 0 0116 11.38a5.119 5.119 0 015.12 5.12A5.119 5.119 0 0116 21.62z",
    fill: "#A50F0F"
  })));
}
export default SvgErrorIcon;